import { render, staticRenderFns } from "./PaymentMessageNumber.vue?vue&type=template&id=04b0cf2c&scoped=true&"
import script from "./PaymentMessageNumber.vue?vue&type=script&lang=js&"
export * from "./PaymentMessageNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b0cf2c",
  null
  
)

export default component.exports